var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpatialAudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1893_2430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.78687 13C11.9969 13 13.7869 11.21 13.7869 9C13.7869 6.79 11.9969 5 9.78687 5C7.57687 5 5.78687 6.79 5.78687 9C5.78687 11.21 7.57687 13 9.78687 13ZM9.78687 7C10.8869 7 11.7869 7.9 11.7869 9C11.7869 10.1 10.8869 11 9.78687 11C8.68687 11 7.78687 10.1 7.78687 9C7.78687 7.9 8.68687 7 9.78687 7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1769 15.56C14.4969 14.7 12.3169 14 9.78687 14C7.25687 14 5.07687 14.7 3.39687 15.56C2.39687 16.07 1.78687 17.1 1.78687 18.22V21H17.7869V18.22C17.7869 17.1 17.1769 16.07 16.1769 15.56ZM15.7869 19H3.78687V18.22C3.78687 17.84 3.98687 17.5 4.30687 17.34C5.49687 16.73 7.41687 16 9.78687 16C12.1569 16 14.0769 16.73 15.2669 17.34C15.5869 17.5 15.7869 17.84 15.7869 18.22V19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1468 1L18.7368 2.41C21.4668 5.14 21.4668 9.58 18.7368 12.31L20.1468 13.72C23.6668 10.21 23.6668 4.51 20.1468 1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3267 10.9C19.2767 8.94996 19.2767 5.77996 17.3267 3.82996L15.9167 5.23996C17.0867 6.40996 17.0867 8.30996 15.9167 9.47996L17.3267 10.9Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1893_2430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(-0.213135)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpatialAudio);
export default __webpack_public_path__ + "static/media/spatial_audio.627411d9529fb50d32d5dd48c1e9dbed.svg";
export { ForwardRef as ReactComponent };